import * as React from "react";
import { Modal } from "react-bootstrap";
import LoginForm from "../LoginForm/LoginForm";
import { container } from "./LoginModal.module.scss";

export const StyledModal: React.FC<any> = (props) => {
  return (
    <Modal centered size="lg" className={container} {...props}>
      {props.children}
    </Modal>
  );
};
export const StyledLoginForm: React.FC<{
  onHide(): void;
  welcomeSubHeading: string;
  location: any;
  isEditReservation?: boolean;
  isFrom?: string;
}> = (props) => {
  return (
    <LoginForm
      className="loginFormModal"
      onSignIn={props.onHide}
      welcomeSubHeading={
        props.welcomeSubHeading ||
        "Sign In To Travel Pass to Complete this Reservation"
      }
      location={props.location}
      isEditReservation={props.isEditReservation}
      isFrom={props.isFrom}
    />
  );
};
